import { useState, useCallback, useContext } from 'react';
import axios from 'axios';
import { ConfigContext } from '../components/shared/ConfigContext';

// Lazily fetched like useMemberships: the workspace menu asks for it each
// time it opens. Fails closed — until the server confirms canCreate, the
// "Create new company" action stays hidden (the backend rejects anyway).
const useCompanyQuota = () => {
  const config = useContext(ConfigContext);
  const [quota, setQuota] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchQuota = useCallback(() => {
    if (!config?.backendUrl) return;
    setLoading(true);
    setError(false);
    axios.get(`${config.backendUrl}/me/company-quota`)
      .then((res) => setQuota(res.data))
      .catch((err) => {
        console.error('Error fetching company quota', err);
        setQuota(null);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, [config]);

  return { quota, canCreate: quota?.canCreate === true, loading, error, fetchQuota };
};

export default useCompanyQuota;
